 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		9: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		9: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"d3ee9a976424546ff603a685411087d3380a87b4","2":"43410695558361827b6658597c66056474968018","3":"6aa58998b7f580ed7d1567f526c2b0222a1d3839","4":"4165be8f0076f8e4fd025cae88bb7940d5497592","5":"b244c1cf12942340152bc48e5617645b816e99f8","6":"8dcf5d258afef6692e0ead92135a9bf0a0316f82","7":"c80f70f273fee75b07756d50cfa493d4d8c9be91","8":"fc545b15a46f46974657176956241dc64d504b59","12":"component---node-modules-gatsby-plugin-offline-app-shell-js","13":"component---src-pages-404-js","14":"component---src-pages-browse-js","15":"component---src-pages-directory-of-services-js","16":"component---src-pages-donation-form-js","17":"component---src-pages-index-js","18":"component---src-pages-my-shortlist-js","19":"component---src-pages-paperfom-payment-failed-js","20":"component---src-pages-paperform-payment-processing-js","21":"component---src-pages-payment-failed-js","22":"component---src-pages-payment-processing-js","23":"component---src-pages-power-to-protect-search-js","24":"component---src-pages-power-to-protect-whanau-maori-js","25":"component---src-pages-preview-custom-page-js","26":"component---src-pages-preview-directory-services-js","27":"component---src-pages-preview-donation-page-js","28":"component---src-pages-preview-embedded-js","29":"component---src-pages-preview-generic-js","30":"component---src-pages-preview-group-js","31":"component---src-pages-preview-guideline-js","32":"component---src-pages-preview-power-to-protect-directory-services-js","33":"component---src-pages-preview-power-to-protect-generic-js","34":"component---src-pages-preview-power-to-protect-group-js","35":"component---src-pages-preview-power-to-protect-widgets-js","36":"component---src-pages-preview-story-js","37":"component---src-pages-preview-widgets-js","38":"component---src-pages-search-js","39":"component---src-pages-styleguide-js","40":"component---src-templates-calculator-page-template-js","41":"component---src-templates-custom-page-template-js","42":"component---src-templates-directory-of-services-template-js","43":"component---src-templates-directory-of-services-template-ptp-js","44":"component---src-templates-generic-page-template-js","45":"component---src-templates-generic-page-template-ptp-js","46":"component---src-templates-guideline-template-js","47":"component---src-templates-health-point-service-template-js","48":"component---src-templates-pages-donation-template-js","49":"component---src-templates-pages-group-template-js","50":"component---src-templates-pages-group-template-ptp-js","51":"component---src-templates-widgets-page-template-js","52":"component---src-templates-widgets-page-template-ptp-js"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"65ef6e258a54240777bd","2":"80287b5861eb707666f5","3":"2a4e3299ca40bbad6f24","4":"9f9cba4ce87675185c50","5":"b96f3d388a367767d4d7","6":"55889d07b1a8f6d60dc6","7":"24330f4a996f88265e56","8":"bca09634883a6a86c6a7","12":"148195328539c5de62b4","13":"33ad6bc4d2e4e58c512b","14":"1fbc81046a87ed0137a8","15":"f69f2bb131c08fbfb36b","16":"f96d4beb4d56bae76fe5","17":"b0d0876f680fd19cf493","18":"eebd005252b3e1d9e143","19":"d6f85d40226361c5402e","20":"94e45cb72bcf3a62c73f","21":"42a62516714339e6a53a","22":"4a0dc4a7fe94744606ca","23":"4223b97ce5e83551a03c","24":"38db5335a6582715e4b4","25":"39f823e222d56b18f645","26":"b8deb5760b23bb3bc1d0","27":"0b8b4a2f5339a2f1b5de","28":"2aa9dbba455b9013e924","29":"a228aff46008822974db","30":"18e8eaf71f0646bd9172","31":"0871526313ac4165ba60","32":"34df88ce147fc6537b02","33":"01acc11206df97b2bdc3","34":"3378d3e38e91975ffd7a","35":"fb097aad5a443616f4b5","36":"50c8489f0e5b50f96d6f","37":"17c978e498e473d5e2cf","38":"a626fdf6e09e147ee825","39":"436538c936b885fe1724","40":"0a9095a3169bcb2d72bd","41":"0253a1bf719f7f58929c","42":"9d386a28ec74f0eb5830","43":"a5da33cc71c965f88938","44":"7d71cf460ce3757265dd","45":"4a787c9a0abbcf12d417","46":"12147ebdb50b168e1b7e","47":"642aa7cc9129f64e9051","48":"dca091bfdd4727539c8d","49":"ba6c8aef192a0582e0cf","50":"aea0828e230057be8a66","51":"d7293beb7daca9417abc","52":"bee277b286b91b394d65"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"d3ee9a976424546ff603a685411087d3380a87b4","2":"43410695558361827b6658597c66056474968018","3":"6aa58998b7f580ed7d1567f526c2b0222a1d3839","4":"4165be8f0076f8e4fd025cae88bb7940d5497592","5":"b244c1cf12942340152bc48e5617645b816e99f8","6":"8dcf5d258afef6692e0ead92135a9bf0a0316f82","7":"c80f70f273fee75b07756d50cfa493d4d8c9be91","8":"fc545b15a46f46974657176956241dc64d504b59","12":"component---node-modules-gatsby-plugin-offline-app-shell-js","13":"component---src-pages-404-js","14":"component---src-pages-browse-js","15":"component---src-pages-directory-of-services-js","16":"component---src-pages-donation-form-js","17":"component---src-pages-index-js","18":"component---src-pages-my-shortlist-js","19":"component---src-pages-paperfom-payment-failed-js","20":"component---src-pages-paperform-payment-processing-js","21":"component---src-pages-payment-failed-js","22":"component---src-pages-payment-processing-js","23":"component---src-pages-power-to-protect-search-js","24":"component---src-pages-power-to-protect-whanau-maori-js","25":"component---src-pages-preview-custom-page-js","26":"component---src-pages-preview-directory-services-js","27":"component---src-pages-preview-donation-page-js","28":"component---src-pages-preview-embedded-js","29":"component---src-pages-preview-generic-js","30":"component---src-pages-preview-group-js","31":"component---src-pages-preview-guideline-js","32":"component---src-pages-preview-power-to-protect-directory-services-js","33":"component---src-pages-preview-power-to-protect-generic-js","34":"component---src-pages-preview-power-to-protect-group-js","35":"component---src-pages-preview-power-to-protect-widgets-js","36":"component---src-pages-preview-story-js","37":"component---src-pages-preview-widgets-js","38":"component---src-pages-search-js","39":"component---src-pages-styleguide-js","40":"component---src-templates-calculator-page-template-js","41":"component---src-templates-custom-page-template-js","42":"component---src-templates-directory-of-services-template-js","43":"component---src-templates-directory-of-services-template-ptp-js","44":"component---src-templates-generic-page-template-js","45":"component---src-templates-generic-page-template-ptp-js","46":"component---src-templates-guideline-template-js","47":"component---src-templates-health-point-service-template-js","48":"component---src-templates-pages-donation-template-js","49":"component---src-templates-pages-group-template-js","50":"component---src-templates-pages-group-template-ptp-js","51":"component---src-templates-widgets-page-template-js","52":"component---src-templates-widgets-page-template-ptp-js"}[chunkId]||chunkId) + "." + {"0":"769854ecdb617c749656","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
